import { render, staticRenderFns } from "./successfulDalog.vue?vue&type=template&id=556f1b24&scoped=true&"
import script from "./successfulDalog.vue?vue&type=script&lang=js&"
export * from "./successfulDalog.vue?vue&type=script&lang=js&"
import style0 from "./successfulDalog.vue?vue&type=style&index=0&id=556f1b24&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "556f1b24",
  null
  
)

export default component.exports